// V101-8-2: the Kubernetes RBAC scope rules, kept free of imports so both the
// manifest registry and the scope lint can use them without an import cycle.
/** The only Kubernetes resources the collector may read, and the only verbs. */
export const K8S_RBAC_RESOURCES = ['deployments', 'statefulsets', 'daemonsets', 'services', 'namespaces'];
export const K8S_RBAC_VERBS = ['get', 'list', 'watch'];
/** Every `<resource>:<verb>` scope the Kubernetes collector's ClusterRole grants. */
export const K8S_RBAC_SCOPES = K8S_RBAC_RESOURCES.flatMap((r) => K8S_RBAC_VERBS.map((v) => `${r}:${v}`));
/**
 * `kubernetes_rbac` profile. A scope is `<resource>:<verb>[,<verb>...]` (an optional
 * `apps/` or `core/` API-group prefix is allowed). It FAILS unless the resource is in
 * K8S_RBAC_RESOURCES and every verb is get/list/watch. So `secrets`, `configmaps`,
 * `pods/exec`, `pods/attach`, `pods/portforward`, any `*` resource and any other
 * verb (create, update, patch, delete, impersonate, bind, escalate, `*`) all fail.
 */
export function lintKubernetesRbac(scopes) {
    const resources = new Set(K8S_RBAC_RESOURCES);
    const verbs = new Set(K8S_RBAC_VERBS);
    return scopes.filter((s) => {
        const m = /^([^:\s]+):([^:\s]+)$/.exec(s.trim());
        if (!m)
            return true;
        const resource = m[1].toLowerCase().replace(/^(apps|core)\//, '');
        const vs = m[2].toLowerCase().split(',');
        return !resources.has(resource) || vs.some((v) => !verbs.has(v));
    });
}
//# sourceMappingURL=kubernetes-rbac.js.map